import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Slot } from '../models/Slot';
import { ReportMapper } from './ReportMapper';

export class SlotMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly reportMapper = new ReportMapper();

  mapGQLModel(data: any): Slot {
    const id = this.gqlIdEncoder.decode(data.id);
    const latestReport = data.lastReport ? this.reportMapper.mapGQLModel(data.lastReport) : null;

    return new Slot(id, data.name, data.description || '', data.traceType, latestReport, data.reportCount || 0, data.tags || []);
  }
}
